<template>
  <!-- レポート作成 -->
  <div id="HolterInspectionsSpecification">
    <div id="container">
      <div class="labelTitle lable">ホルター心電図検査明細書</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>対象日</th><td style="width:400px;"><input type="date" v-model="searchCondition.startDate"/> ～ <input type="date" v-model="searchCondition.endDate"/></td>
            <th>医療機関名</th>
            <td style="width:400px;">
              <input type="text" style="width:270px;" disabled="disabled" v-model="searchCondition.hospitalName"/>
              <b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">医療機関選択</b-button>
            </td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>

      </div>
      <!-- 検索結果 -->
      <div v-if="result.length > 0">
        <div id="item-contens">
            <div class="card-content margin-top">
                <table>
                    <tr>
                      <th>期間</th>
                      <td v-if="data.startDate || data.endDate">{{data.startDate}} ～ {{data.endDate}}</td>
                    </tr>
                    <tr><th>医療機関</th><td>{{data.hospitalName}}</td></tr>
                    <tr><th>担当者</th><td>{{data.staffName}}</td></tr>
                </table>
            </div>
        </div>
        <div class="button-area">
          <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy('inspectionsSpecificationTable')">クリップボードにコピー</b-button>
        </div>
        <div class="table-wrapper">
            <table id="inspectionsSpecificationTable">
                <thead>
                    <tr><th></th><th>患者名</th><th>検査日</th><th>検査種類</th></tr>
                </thead>
                <tbody>
                    <template v-for="(item, index) in result">
                        <tr :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{item.patientName}} 様</td>
                            <td>{{item.inspectionDate}}</td>
                            <td>{{item.kind}}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="button-area">
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>

    </div>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal :selectRole="[role.role_hospital]" :serviceId="serviceId" title="医療機関選択" labelForOrg="医療機関名" @select="setOrganization"></organizationSelectModal>
    </b-modal>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import {service} from "@/components/mock/base/const.js";
export default {
  name: "InspectionsSpecification",
  methods: {
    doSearch: function() {
      if (!this.inputCheck()) {
        return;
      }
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalSpreadsheet.getHolterSpreadsheetInspectionStatementPOST({
            body: _this.searchCondition
          });
        },
        function(result){
          _this.result = result.obj
          _this.data.startDate = _this.replaceSlash(_this.searchCondition.startDate);
          _this.data.endDate = _this.replaceSlash(_this.searchCondition.endDate);
          _this.data.hospitalName = _this.searchCondition.hospitalName;
          if (_this.result.length > 0) {
            _this.data.staffName = _this.result[0].staffName
          }
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    inputCheck: function() {
      if (this.searchCondition.startDate && this.searchCondition.endDate) {
        if (this.searchCondition.startDate > this.searchCondition.endDate) {
          this.showErrorMessage('対象日の開始/終了の関係に誤りがあります。');
          return false
        }
      }

      if (this.searchCondition.hospitalName == '') {
        this.showErrorMessage('医療機関を選択してください。');
        return false
      }
      
      return true
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      var tbody = btable.getElementsByTagName("tbody")[0];
      navigator.clipboard.writeText(tbody.innerText).then(() => {
          this.showMessage("クリップボードにコピーしました。");
        }).catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
    back: function() {
      this.$router.go(-1);
    },
    setOrganization: function(organizationInfo){
      if(organizationInfo){
        this.searchCondition.customerCode = organizationInfo.customerCode,
        this.searchCondition.hospitalName = organizationInfo.orgName
      }
    }
  },
  data() {
    var serviceId = service.holter;
    return {
      role: role,
      result: [],
      data: {
        startDate: "",
        endDate: "",
        hospitalName: "",
        staffName: ""
      },
      searchCondition: {
        startDate: "",
        endDate: "",
        customerCode: "",
        hospitalName: "",
      },
      organizationModalActive: false,
      serviceId,
    };
  },
  filters: {},
  components: {
    organizationSelectModal:OrganizationSelectModal,
  }
};
</script>
<style lang="scss" scoped>
input {
  width: 200px;
}
.table-wrapper {
    max-height: 1100px;
    overflow-y: scroll;
}
#inspectionsSpecificationTable {
    font-size: 100% !important;
}
#inspectionsSpecificationTable tr,
#inspectionsSpecificationTable th,
#inspectionsSpecificationTable td{
    border: black 1px solid;
    text-align: center;
}
#inspectionsSpecificationTable td{
    width: 60px;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/spreadSheet/HolterInspectionsSpecification.vue